import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import "./Sidebar.css";

function Sidebar({ isOpen, toggleSidebar }) {
  const [productDropdown, setProductDropdown] = useState(false);
  const [categoryDropdown, setCategoryDropdown] = useState(false);
  const [projectDropdown, setProjectDropdown] = useState(false);
  const [galleryDropdown, setGalleryDropdown] = useState(false);
  const [blogDropdown, setBlogDropdown] = useState(false);

  return (
    <>
      {/* OVERLAY (mobile) */}
      <div 
        className={`overlay ${isOpen ? "show" : ""}`} 
        onClick={toggleSidebar}
      ></div>

      {/* SIDEBAR */}
      <div className={`sidebar ${isOpen ? "active" : ""}`}>

        <h2 className="sidebar-logo">Savariya Cable Admin</h2>

        <nav className="sidebar-nav">

          <NavLink to="/admin" onClick={toggleSidebar}>
            Dashboard
          </NavLink>

          {/* PRODUCTS */}
          <div className="dropdown">
            <div
              className="dropdown-title"
              onClick={() => setProductDropdown(!productDropdown)}
            >
              Products
              <span>{productDropdown ? "▲" : "▼"}</span>
            </div>

            {productDropdown && (
              <div className="dropdown-content">
                <NavLink to="/admin/products/add" onClick={toggleSidebar}>
                  Add Product
                </NavLink>
                <NavLink to="/admin/products/view" onClick={toggleSidebar}>
                  View Products
                </NavLink>
              </div>
            )}
          </div>

          {/* CATEGORIES */}
          <div className="dropdown">
            <div
              className="dropdown-title"
              onClick={() => setCategoryDropdown(!categoryDropdown)}
            >
              Categories
              <span>{categoryDropdown ? "▲" : "▼"}</span>
            </div>

            {categoryDropdown && (
              <div className="dropdown-content">
                <NavLink to="/admin/categories/add" onClick={toggleSidebar}>
                  Add Category
                </NavLink>
                <NavLink to="/admin/categories/view" onClick={toggleSidebar}>
                  View Categories
                </NavLink>
              </div>
            )}
          </div>

          {/* PROJECTS */}
          <div className="dropdown">
            <div
              className="dropdown-title"
              onClick={() => setProjectDropdown(!projectDropdown)}
            >
              Projects
              <span>{projectDropdown ? "▲" : "▼"}</span>
            </div>

            {projectDropdown && (
              <div className="dropdown-content">
                <NavLink to="/admin/projects/add" onClick={toggleSidebar}>
                  Add Project
                </NavLink>
                <NavLink to="/admin/projects/view" onClick={toggleSidebar}>
                  View Projects
                </NavLink>
              </div>
            )}
          </div>

          {/* GALLERY */}
          <div className="dropdown">
            <div
              className="dropdown-title"
              onClick={() => setGalleryDropdown(!galleryDropdown)}
            >
              Gallery
              <span>{galleryDropdown ? "▲" : "▼"}</span>
            </div>

            {galleryDropdown && (
              <div className="dropdown-content">
                <NavLink to="/admin/gallery/add" onClick={toggleSidebar}>
                  Add Image
                </NavLink>
                <NavLink to="/admin/gallery/view" onClick={toggleSidebar}>
                  View Gallery
                </NavLink>
              </div>
            )}
          </div>

          {/* BLOG */}
          <div className="dropdown">
            <div
              className="dropdown-title"
              onClick={() => setBlogDropdown(!blogDropdown)}
            >
              Blog
              <span>{blogDropdown ? "▲" : "▼"}</span>
            </div>

            {blogDropdown && (
              <div className="dropdown-content">
                <NavLink to="/admin/blog/add" onClick={toggleSidebar}>
                  Add Blog
                </NavLink>
                <NavLink to="/admin/blog/view" onClick={toggleSidebar}>
                  View Blogs
                </NavLink>
              </div>
            )}
          </div>

          <NavLink to="/admin/contact" onClick={toggleSidebar}>
            Contact
          </NavLink>

          <NavLink to="/admin/enquiries" onClick={toggleSidebar}>
            Enquiries
          </NavLink>

        </nav>
      </div>
    </>
  );
}

export default Sidebar;